import { gql } from '@apollo/client';

import { academyFragment } from '../fragments';
import { Academy } from '../../types';
import { AcademyFormInput } from '../../types/form';

export interface UpdateAcademyMutationVariables {
  input: AcademyFormInput;
}

export interface UpdateAcademyMutationResult {
  academy: Academy;
}

export const updateAcademyMutation = gql`
  mutation UpdateAcademyMutation($input: UpdateAcademyMutationInput!) {
    academy(input: $input) @rest(type: "Academy", path: "academy", method: "PUT") {
      ...Academy
    }
  }
  ${academyFragment}
`;
